import { Box, styled, Tooltip } from '@mui/material';

const PREFIX = 'RolesDisplay';

const classes = {
  tooltip: `${PREFIX}-tooltip`,
};

const Roles = styled('div')(({ theme }) => ({
  [`& .${classes.tooltip}`]: {
    width: 160,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

interface RolesDisplayProps {
  roles?: any[];
}

export default function RolesDisplay({ roles }: RolesDisplayProps) {
  const s = (roles || [])
    // .filter((role) => role.userState === 'active') // TODO: this is not in the object right now so add it back if necessary. It may not because it might get filtered on the back end
    .map((role) => role?.userRoleName)
    .sort()
    .join(', ');
  return (
    <Roles>
      <Tooltip title={s}>
        <Box className={classes.tooltip}>{s}</Box>
      </Tooltip>
    </Roles>
  );
}
